module.exports = __webpack_public_path__ + "static/doctor_hero_image-78c9200f1f318cf586e4c4ca4566c303.png";